export default __webpack_public_path__ + "static/media/disqualifiedIcon.869c3343.svg";